import * as React from 'react';

import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Router from './Router';
import { utils } from 'kb-shared';
import * as redux from './redux';
import appFeatureFlags from './config/features';
import { checkAndSetConsent } from './utilities/consent';
import GlobalStyle from './GlobalStyle';
import { NotificationsContainer } from 'utilities/notificationUtils';

const { featureFlagsRetrieved } = redux.features;
const { getFeatureFlagsList } = utils;

type Props = {
  featureFlagsRetrieved: (featureFlags: Record<string, unknown>) => void;
};

type State = {
  stripe: unknown | null;
};

const { REACT_APP_GOOGLE_CLIENT_ID, REACT_APP_SEGMENT_KEY } = process.env;

class App extends React.Component<Props, State> {
  componentDidMount() {
    checkAndSetConsent();
    const featureFlags = getFeatureFlagsList(window.location.search.substring(1), appFeatureFlags);
    this.props.featureFlagsRetrieved(featureFlags);
  }

  render() {
    return (
      <>
        <Helmet>
          <script id="stripe-js" src="https://js.stripe.com/v3/" async defer />
          <meta name="google-signin-client_id" content={REACT_APP_GOOGLE_CLIENT_ID} />
        </Helmet>
        <SegmentAnalytics />
        <NotificationsContainer />
        <GlobalStyle />
        <Router />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch: Function) => ({
  featureFlagsRetrieved: (featureFlags: Record<string, unknown>) =>
    // @ts-ignore
    dispatch(featureFlagsRetrieved(featureFlags))
});

export default connect(null, mapDispatchToProps)(App);

const SegmentAnalytics = () => {
  return (
    <Helmet>
      <script>
        {`
      !(function() {
        var analytics = (window.analytics = window.analytics || []);
        if (!analytics.initialize)
          if (analytics.invoked)
            window.console &&
              console.error &&
              console.error('Segment snippet included twice.');
          else {
            analytics.invoked = !0;
            analytics.methods = [
              'trackSubmit',
              'trackClick',
              'trackLink',
              'trackForm',
              'pageview',
              'identify',
              'reset',
              'group',
              'track',
              'ready',
              'alias',
              'debug',
              'page',
              'once',
              'off',
              'on'
            ];
            analytics.factory = function(t) {
              return function() {
                var e = Array.prototype.slice.call(arguments);
                e.unshift(t);
                analytics.push(e);
                return analytics;
              };
            };
            for (var t = 0; t < analytics.methods.length; t++) {
              var e = analytics.methods[t];
              analytics[e] = analytics.factory(e);
            }
            analytics.load = function(t, e) {
              var n = document.createElement('script');
              n.type = 'text/javascript';
              n.async = !0;
              n.src =
                'https://cdn.segment.com/analytics.js/v1/' +
                t +
                '/analytics.min.js';
              var a = document.getElementsByTagName('script')[0];
              a.parentNode.insertBefore(n, a);
              analytics._loadOptions = e;
            };
            analytics.SNIPPET_VERSION = '4.1.0';
            analytics.load('${REACT_APP_SEGMENT_KEY}');
            analytics.page();
          }
      })()
      `}
      </script>
    </Helmet>
  );
};
